// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1475o","label":"LabeledBox_label__yPIIN"};